import { u, styled } from '../../../shared/theming-sc'

const Table = styled.table`
    border-collapse: collapse;
    font-size: ${u.getFontSize('md')};
    color: ${u.getColor('greyDark')};
    table-layout:fixed;
    border-spacing: 0;
`
const LoaderWrapper = styled.div`
    display:inline-block;
`

export {
  Table,
  LoaderWrapper
}
